import React from "react";

function PerformanceCard() {
  return (
    <section
      className="why_choose_us pt-0 about_page"
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="500"
    >
      <div className="shape_circle float-bob-y">
        <img src="/images/icons/ring_shape.png" alt="Ring Shape" />
      </div>

      <div className="container">
        <div className="row">
          {/* Card 1 */}
          <div className="col-xl-4 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="100"
            >
              <div className="choose_icon">
                <i className="fa-solid fa-arrow-trend-up"></i>
              </div>
              <h4>Growth</h4>
              <p>
                Exponential business expansion through data-driven strategies
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-xl-4 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="200"
            >
              <div className="choose_icon">
                <i className="fa-regular fa-handshake"></i>
              </div>
              <h4>Partnerships</h4>
              <p>Strategic alliances that create mutual value and success</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-xl-4 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <div className="choose_icon">
                <i class="fa-solid fa-shield"></i>
              </div>
              <h4>Excellence</h4>
              <p>Industry-leading standards and award-winning performance</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PerformanceCard;
